import * as R from 'ramda';

import { Icon, IconButton } from '@atom/mui';
import { WorkTemplateFolderTree } from '@atom/types/workTemplate';

import classes from './workTypeFolderTree.module.css';

export interface Props {
  workTemplateFolder: WorkTemplateFolderTree;
  removeWorkTemplateFolder: () => void;
  disabled?: boolean;
}

const WorkTypeFolderTile = ({
  workTemplateFolder,
  removeWorkTemplateFolder,
  disabled = false,
}: Props) => {
  return (
    <div className={classes.templateTile}>
      <div className={classes.tileContent}>
        <div className={classes.tileTitle}>
          {R.pathOr([], ['folderPath'], workTemplateFolder).join(' / ')}
        </div>
      </div>
      <IconButton
        onClick={removeWorkTemplateFolder}
        disabled={disabled}
        size="small"
      >
        <Icon>close</Icon>
      </IconButton>
    </div>
  );
};

export default WorkTypeFolderTile;
